import MESSAGES from '../../../../../appMessages';
import { isValid as isDateTimeValid } from 'date-fns';
import { RMAXLogger } from '../../../../../services/LoggerService/RMAXLogger';

export const getTrailerCounts = (trailerCounts = [], trailerDetails = []) => {
  // Create a map for easy lookup of trailer details by trailerId
  const trailerDetailsMap = trailerDetails.reduce((acc, trailer) => {
    acc[trailer.trailerId] = trailer;
    return acc;
  }, {});

  // Initialize result object with two categories: LG (LiftGate) and NonLG (Non-LiftGate)
  const trailerCountByType = {
    LG: [],
    NonLG: []
  };

  // Iterate through the trailerCounts to build the final result
  trailerCounts.forEach(({ trailerId, trailerCount }) => {
    const { isLiftGateRequired, trailerName, totalCount } = trailerDetailsMap[trailerId] || {};

    if (!trailerName || trailerCount === 0) {
      return; // Skip if trailer name is missing
    }

    if (trailerCount === null) {
      trailerCount = totalCount;
    }

    const countData = { trailerName, count: trailerCount };

    // Categorize trailer count based on whether it's a LiftGate trailer or not
    if (isLiftGateRequired) {
      trailerCountByType.LG.push(countData);
    } else {
      trailerCountByType.NonLG.push(countData);
    }
  });

  return trailerCountByType;
};

export const getStepsData = (data) => {
  if (!data || !data.length) return [];

  const steps = data
    .map((stepData) => {
      const step = {
        id: stepData.validationStepName,
        label: stepData.validationStepLabel,
        message: stepData.message,
        data: stepData.data,
        cityRouteForUnappointedPros: stepData.cityRouteForUnappointedPros
      };
      return step;
    })
    .filter((step) => step.data?.length);
  return steps;
};

export const getValidationReason = (steps, currentStep) => {
  if (!steps || !steps.length) return '';
  if (currentStep < 0 || currentStep >= steps.length) return '';

  return steps[currentStep].message;
};

export const constructShipmentsStatusBar = (data, excludedPros) => {
  const selectedDataLength = data.filter((shipment) => !excludedPros.has(shipment.proId)).length;
  return [
    {
      label: data.length + ' Total Shipments'
    },
    {
      label: selectedDataLength + ' Selected Shipments'
    }
  ];
};

export const getShipmentsData = ({ proIdList, shipmentsList }) => {
  const missingPros = [];
  const shipmentsData = proIdList.map(({ proId }) => {
    const currentShipment = shipmentsList.find((shipment) => proId === shipment.proId);
    if (!currentShipment) {
      missingPros.push(proId);
    }
    return currentShipment;
  });
  if (missingPros?.length > 0) {
    RMAXLogger.warn('Dynamic routing validation shipment data mismatch', {
      missingPros
    });
  }
  return shipmentsData.filter((shipment) => Boolean(shipment));
};

export const isUpdateValid = ({
  proIdList,
  field,
  value,
  currentCell,
  isBulkEdit,
  enqueueSnackbar,
  selectedRows
}) => {
  if (proIdList.length === 0) {
    enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.NO_SHIPMENT_SELECTED, { variant: 'error' });
    return false;
  }
  let isUpdateValid = true;

  switch (field) {
    case 'shipmentEtaDateTime':
      if ((currentCell && currentCell.oldValue && !value) || (!currentCell && !value)) {
        enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.IBETA_EMPTY, { variant: 'error' });
        isUpdateValid = false;
      }
      if (value && !isDateTimeValid(value)) {
        enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.IBETA_INVALID, { variant: 'error' });
        isUpdateValid = false;
      } else if (currentCell && currentCell.oldValue === value) {
        isBulkEdit && enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, { variant: 'info' });
        isUpdateValid = false;
      } else if (isBulkEdit && selectedRows.some((shipment) => shipment.actualArrivalTime)) {
        enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.IBETA_ARRIVED_PRO, { variant: 'error' });
        isUpdateValid = false;
      }
      break;
    case 'pse':
      if (value === '') {
        enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.PSE_EMPTY, { variant: 'error' });
        isUpdateValid = false;
      } else if (value === 0) {
        enqueueSnackbar(MESSAGES.SHIPMENT_UPDATE.PSE_ZEROVALUE, { variant: 'error' });
        isUpdateValid = false;
      } else if (currentCell && Number(currentCell.oldValue) === Number(value)) {
        isBulkEdit && enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, { variant: 'info' });
        isUpdateValid = false;
      }
      break;
  }
  return isUpdateValid;
};
